import styled from 'styled-components';

interface LayoutProps {
  pathname: string;
  path: string;
  visible: boolean;
  theme: string;
}

interface IThemeProps {
  theme: string;
}

export const OptionList = styled.li<LayoutProps>`
  /* ${({ path, pathname }: LayoutProps): string =>
    path === pathname ? 'filter: grayscale(0%) opacity(1);' : '#'} */

  :hover {
    transition: var(--transition-speed);
    background: rgba(49, 130, 206, 0.253);
  }

  /* ${({ visible }: LayoutProps): string =>
    visible ? '' : 'display: none;'} */

  ${({ path, pathname }: LayoutProps): string =>
    path === pathname ? 'border-left: solid 4px #3182ce;' : ''}

  ${({ path, pathname }: LayoutProps): string =>
    path === pathname ? 'background: rgba(49, 130, 206, 0.153);' : ''}

  svg {
    ${({ path, pathname }: LayoutProps): string =>
      path === pathname ? 'filter: grayscale(0%) opacity(1);' : ''}
  }

  span {
    ${({ path, pathname }: LayoutProps): string =>
      path === pathname ? 'color: #3182ce;' : ''}

    ${({ path, pathname }: LayoutProps): string =>
      path === pathname ? 'filter: grayscale(0%) opacity(1);' : ''}
  }
`;

export const Container = styled.div<IThemeProps>`
  .navbar {
    ${({ theme }: IThemeProps): string =>
      theme === 'light' ? 'background: #fff' : 'background: #1F2029'};
  }
`;
